import {
  convertResponsivenessValues,
  generateResponsiveValues,
} from 'hb-builder/components/BuilderComponents/single/Headline/utils/settings';
import FontFamily from 'hb-builder/components/common/SettingsLibrary/CommonSettings/FontFamily';
import NumberSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberSetting';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import type {
  ComponentSettingsTab,
  OnChangeSettingsArgs,
} from 'hb-builder/types/settings';
import { type HeadlineItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/headlineItemAttributes';

const Headline = (props: ComponentSettingsTab<HeadlineItemAttributes>) => {
  const { onChange, item } = props;
  const handleChangeNumbers = ({
    id,
    settingKey,
    value,
  }: OnChangeSettingsArgs) => {
    const key = settingKey?.includes('textFontSize')
      ? 'headlineFontSize'
      : 'headlineLineHeight';
    const forcedAttributes = item.attributes as HeadlineItemAttributes;
    const breakpointsValue = forcedAttributes[key];

    const mobileTabletValue =
      // If it's custom mode, we don't change the responsive's values
      forcedAttributes.isCustomMobileValue
        ? breakpointsValue.s // mobile and tablet values are the same
        : convertResponsivenessValues(value);

    onChange({
      id,
      settingKey: `attributes.${key}`,
      value: generateResponsiveValues({
        s: mobileTabletValue,
        xl: value,
      }),
    });
  };

  const customSettingProps = {
    ...props,
    onChange: handleChangeNumbers,
  };

  return (
    <AccordionTitle isInitiallyOpen title={__('Headline')}>
      <FontFamily
        settingKey="textFontFamily"
        title={__('Font family')}
        {...props}
      />
      <NumberSetting
        settingKey="textFontSize"
        title={__('Font size')}
        {...customSettingProps}
      />
      <NumberSetting
        settingKey="textLineHeight"
        title={__('Line height')}
        {...customSettingProps}
      />
    </AccordionTitle>
  );
};

export default Headline;
